// @ts-nocheck
import React from 'react';
import Form from 'react-bootstrap/Form';

/*

Each field must bring at least:
- id (acts as name etc.)
- label

Optional:
- value
- error
- onChange
- onValidate
- placeholder
- isRequired
- disabled
- prefix
- suffix
- secondaryText

*/

const CheckBox = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  onFocus,
  error,
  isRequired,
  isDisabled,
  prefix,
  suffix,
  secondaryText,
  type,
  errorRenderer,
}) => {
  return (
    <Form.Group className="mb-3" controlId={id}>
      {prefix ? <span>{prefix}</span> : null}
      <Form.Check
        type={type}
        id={`default-checkbox`}
        label={`${label}${isRequired ? ' *' : ''}`}
        value="1"
        disabled={!!isDisabled}
        checked={!!value}
        onChange={() => {
          /* to make React and IE happy */
        }}
        onClick={e => {
          if (typeof onChange === "function") onChange(e.target.checked ? true : false);
        }}
        onBlur={e => {
          if (typeof onBlur === "function") onBlur();
        }}
        onFocus={e => {
          if (typeof onFocus === "function") onFocus();
        }}
      />
      {suffix ? <span>{suffix}</span> : null}
      {secondaryText ? (
        <Form.Text className="text-muted">{secondaryText}</Form.Text>
      ) : null}
      {error ? (
        errorRenderer ? (
          errorRenderer(error)
        ) : (
          <Form.Control.Feedback type="invalid">
            Please fill out this field!
          </Form.Control.Feedback>
        )
      ) : null}
    </Form.Group>
  );
};

export const isValid = (value, config) => {
  if (config.isRequired && (value === '' || typeof value === 'undefined'))
    return false;
  return true;
};

export default CheckBox;
